import { Navigate, Outlet } from "react-router-dom"

export default function PrivateRoutes(isAuth) {
    return isAuth? <Outlet /> : <Navigate to="/auth/login" replace />
}